const PhotoStory = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <rect
        x="7.11111"
        y="45.3333"
        width="49.7778"
        height="9.77778"
        rx="2"
        fill="#2D061B"
      />
      <rect
        x="7.11111"
        y="13.3333"
        width="49.7778"
        height="30.2222"
        rx="2"
        fill="#2D061B"
      />
      <rect x="16" y="20.4444" width="9.77778" height="4.44444" fill="white" />
      <path
        d="M16 9.88889C16 9.3366 16.4477 8.88889 17 8.88889H24.7778C25.3301 8.88889 25.7778 9.3366 25.7778 9.88889V13.3333H16V9.88889Z"
        fill="#2D061B"
      />
      <circle
        cx="42.6667"
        cy="28.4444"
        r="7.88889"
        fill="#EBB268"
        stroke="white"
        stroke-width="2"
      />
    </svg>
  );
};

export default PhotoStory;
